import { useTranslation } from "react-i18next"
import { Check } from "@phosphor-icons/react"
import { Chip } from "@/components/ui/chip"
import {
  useWaitingRoomFilters,
  useWaitingRoomFiltersContext,
} from "@/modules/waiting-room/contexts/waiting-room-filters-context"

type ReviewNeededFilterProps = React.ComponentPropsWithoutRef<typeof Chip>

const ReviewNeededFilter = (props: ReviewNeededFilterProps) => {
  const { filters } = useWaitingRoomFilters()
  const setFilters = useWaitingRoomFiltersContext((state) => state.setFilters)

  const { t } = useTranslation()
  const reviewNeededEnabled = filters.reviewNeeded === true

  const toggleReviewNeededFilter = () => {
    setFilters({ reviewNeeded: reviewNeededEnabled ? null : true })
  }

  return (
    <Chip
      {...props}
      className="h-8 hover:cursor-pointer"
      onClick={toggleReviewNeededFilter}
      checked={reviewNeededEnabled}>
      <div className="flex items-center gap-0.5">
        <Check
          className={`w-${reviewNeededEnabled ? "5" : "0"} overflow-hidden transition-all duration-200`}
          size={20}
        />
        <div className="truncate px-1.5">{t("scheduling.waitingRoom.filters.reviewNeeded")}</div>
      </div>
    </Chip>
  )
}

export { ReviewNeededFilter }
